import { render, staticRenderFns } from "./tahapSeleksiPelamar.vue?vue&type=template&id=fce669dc"
import script from "./tahapSeleksiPelamar.vue?vue&type=script&lang=js"
export * from "./tahapSeleksiPelamar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports